export const summaryTitles = {
  reason: 'Motivo: {{reason}}',
  subReason: 'Submotivo: {{reason}}',
}
